import { USER_API_URL } from '@repo/editor/src/api/constants';
import { DEFAULT_TAKE } from '@repo/editor/src/global/constants';
import {
  GenericApiResponse,
  Post,
  TagType,
  TemplateUseCase,
} from '@repo/editor/src/types';
import { tryFetchRetry } from '@repo/editor/src/utils/fetchRetry';

export interface PostsResponse {
  results: Post[];
  skip: number;
  take: number;
  sort?: string;
  useCase?: TemplateUseCase;
  tags?: TagType[];
  nextCursor?: string | null;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createAPI = ({ url }: { url: string }) => {
  const exploreFeed = async ({
    useCaseSlug,
    take = DEFAULT_TAKE,
    skip = 0,
    sort = 'name',
    seed,
    tags = [],
    token,
  }: {
    useCaseSlug?: string;
    tags?: string[];
    take?: number;
    skip?: number;
    sort?: string;
    seed?: number;
    token?: string;
  }): Promise<GenericApiResponse<PostsResponse>> => {
    const params = {
      take: String(take),
      skip: String(skip),
      sort,
      ...(useCaseSlug && { useCaseSlug }),
      ...(seed && { seed: String(seed) }),
      ...(tags.length > 0 && { tags: tags.join(',') }),
    };
    const urlSearchParams = new URLSearchParams(params);

    return await tryFetchRetry<GenericApiResponse<PostsResponse>>(
      `${url}/posts/v1/explore?${urlSearchParams.toString()}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };

  return { exploreFeed };
};

export default createAPI({ url: USER_API_URL });
